/**
 * Narrows `string | null | undefined` to `string`, filtering out empty,
 * `null`, and `undefined` values. Convenient as a `.filter` predicate
 * when the resulting array should be typed as `string[]` rather than
 * `(string | null | undefined)[]`.
 */
export const isNonEmptyString = (
  value: string | null | undefined
): value is string => Boolean(value);
